import { z } from 'zod'

/** GET /api/usm/v1/admin/tenants/kept-admins. */
export const keptAdminSchema = z.object({
  tenantId: z.string(),
  tenantName: z.string(),
  userId: z.string(),
  email: z.string(),
  displayName: z.string().nullable(),
  since: z.string().nullable(),
  lastCheckedAt: z.string().nullable(),
})

export const keptAdminsReportSchema = z.object({
  notesAvailable: z.boolean(),
  rows: z.array(keptAdminSchema),
})

export const keptAdminsResponseSchema = z.object({
  success: z.boolean(),
  data: keptAdminsReportSchema,
})

export type KeptAdmin = z.infer<typeof keptAdminSchema>
export type KeptAdminsReport = z.infer<typeof keptAdminsReportSchema>
